import { Image } from '@chakra-ui/react';

const CustomCheckbox = ({ isChecked }: { isChecked: Boolean }) => {
  return (
    <>
      {isChecked ? (
        <Image src="/images/ui/checked.svg" />
      ) : (
        <Image src="/images/ui/unChecked.svg" />
      )}
    </>
  );
};
export default CustomCheckbox;
